function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { initHttp } from '../../utils/http';
var http = initHttp();
export function initRefreshTokenWrapper(refreshTokenUrl) {
  var authHeaders = {};
  var refreshedAt = 0;

  function isRecentlyRefreshed() {
    return new Date().valueOf() - refreshedAt < 10000;
  } // wrap request with refresh auth token


  return function (method) {
    // add auth token to request
    var methodWithAuthHeaders = function methodWithAuthHeaders() {
      var originalHeaders = (arguments[2] || {}).headers || {};
      return method.call(this, arguments[0], arguments[1] || {}, _objectSpread({}, arguments[2], {
        headers: _objectSpread({}, authHeaders, {}, originalHeaders)
      }));
    }; // refresh token on auth error and retry call


    return http.catchError(methodWithAuthHeaders, function (reason, callMethod) {
      if (reason.code === 403 && !isRecentlyRefreshed()) {
        return http.post(refreshTokenUrl).then(function (response) {
          authHeaders = response.data.set_headers || {};
          refreshedAt = new Date().valueOf();
          return callMethod();
        });
      }

      return Promise.reject(reason);
    });
  };
}